// extracted by mini-css-extract-plugin
export default {"bottom":"page_bottom__6Xeqq","timer":"page_timer__DjiXz","header":"page_header__h6EPP","div":"page_div__Ts3Ak"};